import React, {  useEffect } from 'react';
import useState from 'react-usestateref';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import {
  readEachConnection,readFiles
} from '../authorization/FetchToken';
import {  
  testFunc,extractFuncDescription,listOfFileNamesPageDir,updateFile
} from '../authorization/FetchToken';
import CodeMirror from '@uiw/react-codemirror';
import { javascript } from "@codemirror/lang-javascript";
import { Button } from "@mui/material";
import {
  Typography,
} from "@mui/material";
import { useAuth } from './AuthContext';
import RefreshIcon from "@mui/icons-material/Refresh";
import InfoTip from "../components/InfoTip";
import {IconButton} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ReactMarkdown from "react-markdown";
import Drawer from "@mui/material/Drawer";

function FunctionsPage() {
  const [funcUDFContent, setFuncUDFContent,funcUDFContentRef] = useState([]);
  const [funcStandardContent, setFuncStandardContent,funcStandardContentRef] = useState([]);
  const [funcCarbonContent, setFuncCarbonContent,funcCarbonContentRef] = useState([]);
  const [funcSqliteContent, setFuncSqliteContent,funcSqliteContentRef] = useState([]);
  const location = useLocation();
  const functions = location.state?.functions || [];
  const [activeTab, setActiveTab] = useState('udf');
  const [searchTerm, setSearchTerm] = useState('');
  const [activeDrawer, setActiveDrawer] = useState(null); 
  const [funcName, setFuncName] = useState(null);
  const [testData, setTestData] = useState(null);
  const [funcCode, setFuncCode] = useState();
  const [funcResult, setFuncResult] = useState(null);
  const [funcCodeFileContent, setfuncCodeFileContent,funcCodeFileContentRef] = useState("");
  const [funcNameFileContent, setfuncNameFileContent,funcNameFileContentRef] = useState([]);
  const [apiKey, setApiKey] = useState("");
  const [showKey, setShowKey] = useState(false);
  const [selectedFilePath,setSelectedFilePath,selectedFilePathRef] = useState('');
  const [dataFiles, setDataFiles] = useState([]);
  const [firstFolderName, setFirstFolderName] = useState('');
 const [loggedInUserRole,setloggedInUserRole] = useState("")
 const [successMessage, setSuccessMessage] = useState('');
 const [showSuccessMessage, setShowSuccessMessage] = useState(false);
 const [errorMessage, setErrorMessage,errorMessageRef] = useState(false);
 const [showErrorMessage, setShowErrorMessage] = useState(false);
 const [loading, setLoading] = useState(true);
 const [openDoc, setOpenDoc] = useState(false);
 const [doc, setDoc] = useState("");

  const DRAWER_WIDTHS = {
    functions: 700,
    apply:700
  };

const { userSessionRef} = useAuth();

  useEffect(() => {
    if (!userSessionRef) return;  
    handleShowFunctions();
    //getUploadedFiles();
  }, [userSessionRef]);


const handleShowFunctions = async () => {
    try {
      try {
        const udfFuncs = await readEachConnection("functions", "functions", userSessionRef.current["orgName"]);
        setFuncUDFContent(udfFuncs || []);
        console.log("UDF functions",udfFuncs);
      } catch (e) {
        console.warn("UDF functions failed", e);
        setFuncUDFContent([]); // fallback
      }
      const standardFuncs= await readFiles("boolean", "documents","functions","functions",`${process.env.REACT_APP_OMEGAPI_FILES_DATA_DIR}`) ;
      setFuncStandardContent(standardFuncs);
      const carbonFuncs= await readFiles("boolean", "documents","functions","carbon_emission_calculations",`${process.env.REACT_APP_OMEGAPI_FILES_DATA_DIR}`) ;
      setFuncCarbonContent(carbonFuncs);
      const sqliteFuncs= await readFiles("boolean", "documents","functions","sqlite_functions",`${process.env.REACT_APP_OMEGAPI_FILES_DATA_DIR}`);
      setFuncSqliteContent(sqliteFuncs);
    } catch (err) {
      console.error("Failed to fetch functions:", err);
    }
  };

 const TABS = [
  { key: "udf", label: "User-Defined Functions", source: () => funcUDFContentRef.current },
  { key: "standard", label: "Invertible Functions", source: () => funcStandardContentRef.current },
  { key: "carbon_emission", label: "Carbon Emission Calculations", source: () => funcCarbonContentRef.current },
  { key: "sqlite_functions", label: "Sqlite Functions", source: () => funcSqliteContentRef.current },
];

  const activeTabObj = TABS.find(t => t.key === activeTab) || TABS[0];
  /*
  let activeTabObj = TABS.find(t => t.key === activeTab) || TABS[0];
  if (userSessionRef.current["role"] =="INDIVIDUAL_USER") {
    activeTabObj = TABS.find(t => t.key === activeTab) || TABS[1];
  }
  */
  const sourceList = activeTabObj.source() || [];
  let filteredFunctions = [];
  if (sourceList.length > 0) {
  filteredFunctions = sourceList.filter(fn =>
  fn.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  fn.signature.toLowerCase().includes(searchTerm.toLowerCase()) ||
  fn.description.toLowerCase().includes(searchTerm.toLowerCase())
  );
  } 
  console.log("activeTabObj::111",filteredFunctions)

 const handleSaveFunction = async () => {
    console.log("filteredFunctions::1",filteredFunctions)
    const funcDesc = await extractFuncDescription(funcCode,funcName)
    console.log('funcDesc:11',JSON.stringify(funcDesc));
    //setfuncCodeFileContent([...funcCodeFileContent,funcCode])
    setfuncCodeFileContent(funcCodeFileContent)
    const numArgs = funcDesc["signature"].split("(")[1].split(",").length;
    console.log("numArgs::1",numArgs)
    const funcDetails = {"name": funcName, "args": numArgs,"description":funcDesc["description"], "signature": funcDesc["signature"],"body":funcCode}
    //setfuncNameFileContent([...funcNameFileContent,funcDetails])
    setfuncNameFileContent([funcDetails])
    console.log('funcJsonName:22',JSON.stringify(funcNameFileContentRef.current));
    const funcJsonName = await updateFile("functions","functions",funcNameFileContentRef.current,"append",userSessionRef.current["orgName"]);
    console.log('funcJsonName:11',  funcJsonName);
 }

 const handleDeleteFunction = async () => {
  const funcDetails = {"name": funcName}
  setfuncNameFileContent([funcDetails])
  console.log('funcJsonName:22',JSON.stringify(funcNameFileContentRef.current));
  const funcJsonName = await updateFile("functions","functions",funcNameFileContentRef.current,"delete", userSessionRef.current["orgName"]);
}

const getUploadedFiles = async () => {
  try {
    const path =  "/home/stateFiles/" + userSessionRef.current["orgName"] + "/" + `${process.env.REACT_APP_ARCHITECTURE_NAME}` + "/uploads"
    const filesList = await listOfFileNamesPageDir(path);

    setDataFiles(filesList);
    setFirstFolderName(filesList.info.name || '');
    console.log("fetching files::1", JSON.stringify(filesList));
  } catch (error) {
    console.error('Error fetching uploads:', error);
  }
};

const handleLoadFunction = async () => {

  //console.log("funcUDFContentRef.current::1", JSON.stringify(funcUDFContentRef.current));
  const filterFunc = funcUDFContentRef.current.filter((e) => e.name == funcName);
  console.log("funcUDFContentRef.current::11", filterFunc[0]["body"],funcName);
  //setfuncCodeFileContent(filterFunc[0]["body"])
  //console.log("funcUDFContentRef.current::111", funcCodeFileContentRef.current);
  return filterFunc[0]["body"]
}

const handleRefresh = async () => {
  setLoading(true);
  try {
    await handleShowFunctions();
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="main-container">
    <div style={{ padding: '1rem' }}>
    <div style={{ display: "flex", alignItems: "center", gap: "8px",marginBottom: '1rem',}}>
    <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: "#0a2540",
            fontFamily: "'Inter', 'Segoe UI', sans-serif",
            letterSpacing: "0.3px",
          }}
        >
         Functions
        </Typography>
        <InfoTip
        keyword="create_list_functions"
        onLoad={(text) => {
          setDoc(text);
          setOpenDoc(true);
        }}
        />
        </div>

      {/* Search bar */}
      <div
      style={{
        display: "flex",
        alignItems: "center", // ✅ vertical alignment
        gap: "96px",
        padding: "1rem",
      }}
    >
      <input
        type="text"
        placeholder="Search functions..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{
          width: '20%',
          padding: '0.5rem',
          marginBottom: '1rem',
          fontSize: '1rem'
        }}
      />
        <Button
          variant="contained"
          color="primary"
          startIcon={<RefreshIcon />}
          onClick={handleRefresh}
          sx={{
            textTransform: "none",  
            fontSize: "13px",
            borderRadius: "6px",
            paddingX: 1.5,
            paddingY: 0.75,
            mr: 1.5,
            mb:2,
            backgroundColor: "#2563eb"  
          }}
        >
          Refresh List
      </Button>
      </div>



      {/* Tabs */}
      <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
    {/* === CATEGORY TABS === */}
    <nav
  style={{
    display: "flex",
    gap: "0.75rem",
    marginBottom: "2rem",
    borderBottom: "1px solid #e2e8f0",
    paddingBottom: "0.5rem",
  }}
>
  
{TABS.map((tab) => (
    <button
      key={tab.key}
      onClick={() => setActiveTab(tab.key)}
      style={{
        background: "none",
        border: "none",
        padding: "0.5rem 1rem",
        fontSize: "1rem",
        fontWeight: 800,
        color: activeTab === tab.key ? "#1d4ed8" : "#64748b",
        borderBottom:
          activeTab === tab.key
            ? "2px solid #3b82f6"
            : "2px solid transparent",
        cursor: "pointer",
        transition: "all 0.2s ease",
      }}
    >
      {tab.label}
    </button>
  ))}
</nav>
</div>
  {/* Disclaimer */}
  {activeTab === "carbon_emission" && (
  <div
    style={{
      background: "#fef3c7",
      color: "#92400e",
      padding: "0.75rem 1rem",
      borderRadius: "6px",
      marginBottom: "10px",
      fontSize: "0.9rem",
      border: "1px solid #fde68a",
    }}
  >
    ⚠️ The emission values generated by this software are derived from publicly available CBAM default factors published by the European Union (see https://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32025R2621). These calculations are provided for informational purposes only and do not constitute legal, regulatory, or compliance advice. While reasonable efforts are made to reflect the published data, no warranty is given regarding accuracy, completeness, or suitability for official CBAM reporting. Users remain solely responsible for verifying all results and ensuring compliance with applicable laws and regulations. The official EU legislation and any subsequent amendments take precedence over the outputs of this software.
  </div>
)}
{activeTab === "sqlite_functions" && (
  <div
    style={{
      background: "#fef3c7",
      color: "#92400e",
      padding: "0.75rem 1rem",
      borderRadius: "6px",
      marginBottom: "10px",
      fontSize: "0.9rem",
      border: "1px solid #fde68a",
    }}
  >
    ⚠️ The functions listed here are Built-In Scalar SQL Functions taken from https://sqlite.org/lang_corefunc.html.
    While we tried to include as many functions as possible here, but some like JSON and Window functions are not listed.
    Please refer to the offical SQLite documentation for further information.
  </div>
)}

      {/* Function list */}
      <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
  {filteredFunctions.length === 0 ? (
    <p style={{ fontStyle: "italic", color: "gray" }}>
      No functions found for this tab.
    </p>
  ) : (
    filteredFunctions.map((fn, idx) => (
      <li
        key={idx}
        style={{
          marginBottom: "2rem",
          padding: "1.5rem",
          borderRadius: "12px",
          background: "#f9fafb",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          border: "1px solid #e5e7eb",
        }}
      >
        <ReactMarkdown
          components={{
            h3: ({ node, ...props }) => (
              <h3
                style={{
                  color: "#1d4ed8",          // ✅ Deep blue header
                  fontSize: "1.25rem",
                  fontWeight: 800,
                  marginBottom: "0.5rem",
                  fontFamily: "'Inter', system-ui, sans-serif",
                }}
                {...props}
              />
            ),
            p: ({ node, ...props }) => (
              <p
                style={{
                  margin: "0.5rem 0",
                  color: "#334155",
                  fontWeight: 500,
                  fontSize: "0.95rem",
                  lineHeight: 1.6,
                }}
                {...props}
              />
            ),
            code: ({ node, ...props }) => (
              <code
                style={{
                  background: "#e0f2fe",
                  color: "#1e3a8a",
                  padding: "2px 6px",
                  borderRadius: "6px",
                  fontSize: "0.9rem",
                  fontFamily: "monospace",
                }}
                {...props}
              />
            ),
          }}
        >
          {`### ${fn.name}

**Signature:** \`${fn.signature}\`

${fn.description}

**Returns:** ${fn.returns}
`}
        </ReactMarkdown>
      </li>
    ))
  )}
</ul>
 
    </div>

    <div
    style={{
      position: "fixed",
      top: 0,
      right: 0,
      width: activeDrawer ? DRAWER_WIDTHS[activeDrawer] : 0,
      height: "100%",
      transition: "width 0.3s ease",
      overflow: "hidden",
      background: "#fff",
      borderLeft: activeDrawer ? "1px solid #ccc" : "none",
      boxShadow: activeDrawer ? "-2px 0px 5px rgba(0,0,0,0.2)" : "none",
      display: "flex",
      flexDirection: "column",
      zIndex: 1000,
    }}
  >

    {/* Functions Drawer */}
  {activeDrawer === "functions" && (
    <div style={{ flex: 1, padding: "20px" }}>
  {showErrorMessage && (
  <div
    className="error-message"
    id="error-banner"
    style={{
      position: "relative",
      backgroundColor: "#fee2e2",
      color: "#b91c1c",
      padding: "12px 40px 12px 12px",
      borderRadius: "6px",
      marginBottom: "12px",
      fontWeight: 500,
      fontSize: "14px",
    }}
  >
    <span>ERROR OCCURRED: {errorMessageRef.current}</span>
    <button
      onClick={() => setShowErrorMessage(false)}
      style={{
        position: "absolute",
        top: "8px",          // moves it to the top
        right: "10px",       // aligns it to the right edge
        background: "none",
        border: "none",
        cursor: "pointer",
        color: "#b91c1c",
        fontSize: "18px",
        fontWeight: "bold",
        lineHeight: "0", 
      }}
    >
      ×
    </button>
  </div>
)}

    {showSuccessMessage && (
    <div
      className="success-message"
      id="success-banner"
      style={{
        position: "relative",
        backgroundColor: "#dcfce7",
        color: "#166534",
        padding: "12px 40px 12px 12px",
        borderRadius: "6px",
        marginBottom: "12px",
        fontWeight: 500,
        fontSize: "14px",
      }}
    >
      <span>{successMessage}</span>
      <button
        onClick={() => setShowSuccessMessage(false)}
        style={{
          position: "absolute",
          top: "8px",          // moves it to the top
          right: "10px",       // aligns it to the right edge
          background: "none",
          border: "none",
          cursor: "pointer",
          color: "#b91c1c",
          fontSize: "18px",
          fontWeight: "bold",
          lineHeight: "0", 
        }}
      >
        ×
      </button>
    </div>
  )}

      <h3>Create and Test RHAI Functions</h3>

      <div className="form-field">
        <label htmlFor="fileNameInput">Name</label>
        <input
          type="text"
          id="fileNameInput"
          className="form-control"
          value={funcName}
          onChange={(e) => setFuncName(e.target.value)}
          placeholder="Same as function name..."
        />
      </div>

      <div className="form-field" style={{ marginTop: "16px" }}>
        <label htmlFor="fileNameInput">Test Data</label>
        <input
          type="text"
          id="fileNameInput"
          className="form-control"
          value={testData}
          onChange={(e) => setTestData(e.target.value)}
          placeholder="Enter Test data..."
        />
      </div>
      <div style={{ marginTop: "16px" }}>
        <CodeMirror
          value={
            typeof funcCode === "string"
              ? funcCode
              : JSON.stringify(funcCode, null, 2)
          }
          height="300px"
          extensions={[javascript()]}
          onChange={(value) => setFuncCode(value)}
          style={{
            border: "1px solid #ccc",
            borderRadius: "6px",
            fontSize: "14px",
          }}
        />
      </div>
      <div style={{ display: "flex", flexDirection: "row", gap: "12px", alignItems: "center"}}>
      <button
        style={{
          marginTop: "16px",
          padding: "6px 12px",     // smaller size
          fontSize: "0.85rem",     // smaller font
          borderRadius: "4px",
          backgroundColor: "#1f8a70",
          color: "#fff",
          border: "none",
          cursor: "pointer",
          boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
          transition: "all 0.2s ease-in-out",
        }}
        onClick={async () => {
          if (!funcName || funcName.trim() === "") {
            //alert("Function Name cannot be empty");
            setErrorMessage("Function Name cannot be empty")
            setShowErrorMessage(true)
            return;
          }
          try {
            const response = await testFunc(funcName, funcCode, testData,userSessionRef.current["orgName"]);
            const text =
              typeof response === "string"
                ? response
                : await response.text();
            setFuncResult(text);
          } catch (err) {
            //setFuncResult(`Error: ${err.message}`);
            setErrorMessage(`Error: ${err.message}`)
            setShowErrorMessage(true)
          }
        }}
        style={{ marginTop: "16px" }}
      >
        Test Function
      </button>
      <button
        style={{
          marginTop: "16px",
          padding: "6px 12px",     // smaller size
          fontSize: "0.85rem",     // smaller font
          borderRadius: "4px",
          backgroundColor: "#1f8a70",
          color: "#fff",
          border: "none",
          cursor: "pointer",
          boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
          transition: "all 0.2s ease-in-out",
        }}
        onClick={async () => {
          if (!funcName || funcName.trim() === "") {
            //alert("Function Name cannot be empty.");
            setErrorMessage("Function Name cannot be empty")
            setShowErrorMessage(true)
            return;
          }
          try {
            const response = await handleSaveFunction();
            //setFuncResult("Function successfully saved");
            setSuccessMessage("Function successfully saved")
            setShowSuccessMessage(true)
          } catch (err) {
            //setFuncResult(`Error: ${err.message}`);
            //setFuncResult(`Error: Either the entries in the signature and Name field mismatch or description doesn't exist`);
            setErrorMessage("Error: Either the entries in the signature and Name field mismatch or description doesn't exist")
            setShowErrorMessage(true)
          }
        }}
        style={{ marginTop: "16px" }}
      >
        Save
      </button>

      <button
        style={{
          marginTop: "16px",
          padding: "6px 12px",     // smaller size
          fontSize: "0.85rem",     // smaller font
          borderRadius: "4px",
          backgroundColor: "#1f8a70",
          color: "#fff",
          border: "none",
          cursor: "pointer",
          boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
          transition: "all 0.2s ease-in-out",
        }}
        onClick={async () => {
          if (!funcName || funcName.trim() === "") {
            //alert("Function Name cannot be empty.");
            setErrorMessage("Function Name cannot be empty")
            setShowErrorMessage(true)
            return;
          }
          try {
            const response = await handleLoadFunction();
            setFuncCode(response);
          } catch (err) {
            setErrorMessage(`Error: Cannot load function.Check if name is correct`);
            setShowErrorMessage(true)
          }
        }}
        style={{ marginTop: "16px" }}
      >
        Load Function
      </button>

      <button
        style={{
          marginTop: "16px",
          padding: "6px 12px",     // smaller size
          fontSize: "0.85rem",     // smaller font
          borderRadius: "4px",
          backgroundColor: "#1f8a70",
          color: "#fff",
          border: "none",
          cursor: "pointer",
          boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
          transition: "all 0.2s ease-in-out",
        }}
        onClick={async () => {
          if (!funcName || funcName.trim() === "") {
            //alert("Function Name cannot be empty.");
            setErrorMessage("Function Name cannot be empty.")
            setShowErrorMessage(true)
            return;
          }
          try {
            const response = await handleDeleteFunction();
            setFuncCode(response);
            setSuccessMessage(`Funtion ${funcName} deleted`);
            setShowSuccessMessage(true)
          } catch (err) {
            //setFuncResult(`Error: Cannot delete function.Check if name is correct`);
            setErrorMessage(`Error: Cannot delete function.Check if name is correct`)
            showErrorMessage(true)
          }
        }}
        style={{ marginTop: "16px" }}
      >
        Delete
      </button>
      </div>
      <div style={{ marginTop: "16px", flexDirection: "row", gap: "12px", alignItems: "center" }}>
      <textarea
        className="form-control"
        placeholder="Test Result"
        style={{
          width: "70%",
          height: "100px",
          fontFamily: "monospace",
          resize: "none",
        }}
        value={funcResult}
        onChange={(e) => setFuncResult(e.target.value)}
      />
      </div>

    </div>
    
  )}


{/* === Control Buttons (Pull Tabs) === */}
{activeDrawer === null && userSessionRef.current["role"] !=="read" && userSessionRef.current["role"] !=="INDIVIDUAL_USER"  && (
  <>
    {/* Functions button */}
    <Button
      onClick={() => setActiveDrawer("functions")}
      variant="contained"
      size="small"
      sx={{
        position: "fixed",
        top: "20%",
        right: 0,
        transform: "translateY(-50%)",
        borderRadius: "8px 0 0 8px",
        zIndex: 1100,
        backgroundColor: "#2563eb"
      }}
    >
      Create RHAI Functions ⬅
    </Button>

  </>
)}



{/* Show close button only when a drawer is open */}
{activeDrawer && (
  <Button
    onClick={() => setActiveDrawer(null)}
    variant="contained"
    size="small"
    sx={{
      position: "fixed",
      top:
        activeDrawer === "logs"
          ? "5%"
          : activeDrawer === "databases"
          ? "15%"
          : "25%",
      right: DRAWER_WIDTHS[activeDrawer],
      transform: "translateY(-50%)",
      borderRadius: "8px 0 0 8px",
      zIndex: 1100,
      backgroundColor: "#2563eb",
      "&:hover": {
        backgroundColor: "#1565c0",
      },
    }}
  >
    Close {activeDrawer.charAt(0).toUpperCase() + activeDrawer.slice(1)} ➡
  </Button>
)}

    </div>


  <Drawer
  anchor="right"
  open={openDoc}
  onClose={() => setOpenDoc(false)}
  >

  <div
    style={{
      width: "420px",
      height: "100%",
      display: "flex",
      flexDirection: "column"
    }}
  >

    {/* Header */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px 16px",
        borderBottom: "1px solid #ddd"
      }}
    >

      <strong>How to use features on this page?</strong>

      <IconButton onClick={() => setOpenDoc(false)}>
        <CloseIcon />
      </IconButton>

    </div>

    {/* Markdown Content */}
    <div
      style={{
        padding: "20px",
        overflowY: "auto",
        flex: 1
      }}
  >

  <ReactMarkdown
  components={{
    img: ({ node, ...props }) => (
      <img
        src={`/docs/${props.src}`}
        alt={props.alt}
        style={{
          maxWidth: "100%",
          borderRadius: "8px",
          marginTop: "12px",
        }}
      />
    ),
  }}
  >
  {doc}
  </ReactMarkdown>

    </div>

  </div>

</Drawer>

    </div>
  );
}

export default FunctionsPage;
